import { GATE_CATALOG_ITEM_TYPES } from "../../../enums/gateCatalogItemTypes.enum";
import { Reference } from "../../shared/refs";

export interface ArticleObject {
  id?: string;
  label: string;
  make: Reference;
  componentType?: Reference;
  articleNumber?: string;
  enableInspection?: boolean;
  loadChanges?: number | null;
  operatingTime?: number | null;
  enableExchange?: boolean;
  maxLoadChanges?: number | null;
  maxOperatingTime?: number | null;
}

export class Article {
  id?: string;
  label: string;
  make: Reference;
  componentType?: Reference;
  articleNumber?: string;
  enableInspection?: boolean;
  loadChanges?: number | null;
  operatingTime?: number | null;
  enableExchange?: boolean;
  maxLoadChanges?: number | null;
  maxOperatingTime?: number | null;
  public gateCatalogItemType: string;

  constructor(article: ArticleObject) {
    this.id = article.id;
    this.label = article.label;
    this.make = article.make;
    this.componentType = article.componentType;
    this.articleNumber = article.articleNumber;
    this.enableInspection = article.enableInspection;
    if (article.loadChanges !== undefined) this.loadChanges = article.loadChanges;
    if (article.operatingTime !== undefined) this.operatingTime = article.operatingTime;
    this.enableExchange = article.enableExchange;
    if (article.maxLoadChanges !== undefined) this.maxLoadChanges = article.maxLoadChanges;
    if (article.maxOperatingTime !== undefined) this.maxOperatingTime = article.maxOperatingTime;
    this.gateCatalogItemType = GATE_CATALOG_ITEM_TYPES.ARTICLE;
  }

  public set properties(article: ArticleObject) {
    this.label = article.label;
    this.componentType = article.componentType;
    this.enableInspection = article.enableInspection;
    this.articleNumber = article.articleNumber;
    this.loadChanges = article.loadChanges;
    this.operatingTime = article.operatingTime;
    this.enableExchange = article.enableExchange;
    this.maxLoadChanges = article.maxLoadChanges;
    this.maxOperatingTime = article.maxOperatingTime;
  }

  public get values() {
    const article: ArticleObject = {
      label: this.label,
      make: this.make,
    };
    if (this.make) {
      article.make = { id: this.make.id };
    }

    if (this.articleNumber) {
      article.articleNumber = this.articleNumber;
    }

    if (this.enableInspection !== undefined && this.enableInspection !== null) {
      article.enableInspection = this.enableInspection;
    }

    article.loadChanges = this.loadChanges;

    article.operatingTime = this.operatingTime;

    if (this.enableExchange !== undefined && this.enableExchange !== null) {
      article.enableExchange = this.enableExchange;
    }

    article.maxLoadChanges = this.maxLoadChanges;

    article.maxOperatingTime = this.maxOperatingTime;

    return article;
  }
}
